import { render } from "./sectorProduct.vue?vue&type=template&id=e07bd0a8&lang=pug"
import script from "./sectorProduct.vue?vue&type=script&lang=js"
export * from "./sectorProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/sectorProduct.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e07bd0a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e07bd0a8', __exports__)) {
    api.reload('e07bd0a8', __exports__)
  }
  
  module.hot.accept("./sectorProduct.vue?vue&type=template&id=e07bd0a8&lang=pug", () => {
    api.rerender('e07bd0a8', render)
  })

}


export default __exports__